class ProductOptionChoices {
  /**
   * @type {Object} jQuery elements
   */
  elements = {};

  /**
   * @param {jQuery} element
   */
  constructor(mainElement) {
    this.loadElements(mainElement);
    this.setEventListeners();
    this.showMainElementText();
  }

  /**
   * Loads the elements to be used in the class.
   * @param {jQuery} element
   */
  loadElements(mainElement) {
    this.elements.mainElement = mainElement;
    this.elements.form = mainElement.parents('.product-main').find('[data-product-form]');
  }

  /**
   * Sets the event listeners for the class.
   */
  setEventListeners() {
    this.elements.form.on(
      'change',
      () => {
        this.showMainElementText();
      }
    );
  }

  /**
   * Adds text to the main element.
   */
  showMainElementText() {
    const text = this.getMainElementText();
    this.elements.mainElement.text(text);
  }

  /**
   * Gets the text for the main element.
   * @returns {string}
   */
  getMainElementText() {
    const optionNames = this.elements.form.data('option-names').split(',');

    if (optionNames.length === 1 && optionNames[0] === '') {
      return '';
    }

    if (!this.elements.form.length) {
      return '';
    }

    const formData = new FormData(this.elements.form.get(0));
    let optionValues = [];

    for (const optionName of optionNames) {
      const optionValue = formData.get(optionName);
      
      if (!optionValue) {
        continue;
      }

      optionValues.push(optionValue);
    }

    return optionValues.join(', ');
  }
}

(async() => {
  // Wait for dependencies to load.
  await new Promise(
    (resolve) => {
      const interval = setInterval(
        () => {
          if (typeof jQuery == 'undefined') {
            return;
          }
          clearInterval(interval);
          resolve();
        },
        10
      );
    }
  );

  const elements = jQuery('.product-option-choices');
  elements.each(
    (index) => {
      new ProductOptionChoices(elements.eq(index));
    }
  );
})();
